<template>
    <div class="pp-lottery-winnings">
        <DsDropdown v-model="selectedOption" :options="options" id="winnings-dropdown" />
        <DsTable>
            <DsRow>
                <DsCell type="th">Pořadí</DsCell>
                <DsCell type="th">Uhodnutá čísla</DsCell>
                <DsCell type="th">Výherní násobek</DsCell>
            </DsRow>
            <DsRow v-for="(order, index) in winningOrdersGrid[selectedOption]" :key="index">
                <DsCell>{{ index + 1 }}. pořadí</DsCell>
                <DsCell>{{ order[0] }}</DsCell>
                <DsCell><strong v-html="formatMultiple(order[1])"></strong></DsCell>
            </DsRow>
        </DsTable>
    </div>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import DsDropdown from "@sazka/design-system/src/forms/components/ds-dropdown.vue";
import { DsDropdownItemModel } from "@sazka/design-system/src/forms/components/ds-dropdown/ds-dropdown-models";

const options: DsDropdownItemModel[] = Array.from({ length: 6 }, (_, index) => ({
    value: index,
    label: `SÁZKA NA ${7 - index} ${LotteryParser.getNumberLabel(7 - index).toUpperCase()}`,
}));

const selectedOption = ref(0);

const winningOrdersGrid = [
    [
        [7, 10000],
        [6, 200],
        [5, 12],
        [4, 3],
        [3, 2],
        [2, 1],
    ],
    [
        [6, 2000],
        [5, 100],
        [4, 12],
        [3, 2],
        [2, 1],
    ],
    [
        [5, 200],
        [4, 16],
        [3, 3],
        [2, 2],
    ],
    [
        [4, 100],
        [3, 11],
        [2, 2],
    ],
    [
        [3, 12],
        [2, 2],
        [1, 1],
    ],
    [
        [2, 9],
        [1, 1],
    ],
];

const formatMultiple = (multiple: number) => `${StringUtils.formatNumber(multiple)}x`;
</script>
